import { __assign, __rest, __spreadArray } from "tslib";
import React, { useState } from 'react';
import classnames from 'classnames';
import Input from '../../Input';
import s from './C01H.scss';
var C01H = function (_a) {
    var submitIcon = _a.submitIcon, onSubmit = _a.onSubmit, onInputValidate = _a.onInputValidate, value = _a.value, onChange = _a.onChange, onKeyPress = _a.onKeyPress, loading = _a.loading, _b = _a.inputValidator, inputValidator = _b === void 0 ? function (x) { return !!x; } : _b, className = _a.className, props = __rest(_a, ["submitIcon", "onSubmit", "onInputValidate", "value", "onChange", "onKeyPress", "loading", "inputValidator", "className"]);
    var _c = useState(value), currentValue = _c[0], setCurrentValue = _c[1];
    var _d = useState(inputValidator(currentValue)), canSubmit = _d[0], setCanSubmit = _d[1];
    function doSubmit() {
        if (canSubmit && !loading) {
            onSubmit(currentValue);
        }
    }
    return (React.createElement(Input, __assign({ className: classnames(className, canSubmit && s['valid']), value: currentValue, afterInput: React.createElement("button", { onClick: doSubmit, className: classnames(s['submit-icon'], !canSubmit && s['disabled']) }, submitIcon), skin: s, onChange: function (changedValue) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            setCurrentValue(changedValue);
            onChange && onChange.apply(void 0, __spreadArray([changedValue], args));
            var isValid = inputValidator(changedValue);
            if (isValid !== canSubmit) {
                setCanSubmit(isValid);
            }
            onInputValidate && onInputValidate(isValid, changedValue);
        }, onKeyPress: function (event) {
            onKeyPress && onKeyPress(event);
            if (!event.defaultPrevented && event.key === 'Enter') {
                doSubmit();
            }
        } }, props)));
};
C01H.displayName = 'C01H';
export default C01H;
//# sourceMappingURL=C01H.js.map